export enum CONTEXT_STATE {
    INIT = 'INIT',
    RESOLVED = 'RESOLVED',
    RESOLVE_ERROR = 'RESOLVE_ERROR',
}
